
import React from "react";
import { Button } from "@/components/ui/button";

interface Step2NumberActionsProps {
  tenant_id?: string;
  twilio_sid?: string;
  handleManualImport: () => void;
}

/**
 * Component for displaying action buttons in the number setup step
 */
const Step2NumberActions = ({
  tenant_id,
  twilio_sid,
  handleManualImport,
}: Step2NumberActionsProps) => {
  if (!tenant_id || !twilio_sid) return null;

  return (
    <div className="flex justify-end">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="mb-3"
        onClick={handleManualImport}
      >
        Import Numbers from Twilio
      </Button>
    </div>
  );
};

export default Step2NumberActions;
